import { useTranslation } from 'react-i18next';

import type { ConfigBankAccount } from '../../../payout/types';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export type BankAccountAutocompleteProps = {
    name: string;
    error?: boolean;
    required?: boolean;
    disabled?: boolean;
    helperText?: string;

    fullWidth?: boolean;
    freeSolo?: boolean;
    bankAccounts: ConfigBankAccount[];
    onChange: (name: string, value: string | ConfigBankAccount | null, type: 'bban' | 'iban') => void;
}

const BankAccountAutocomplete = ({
    name,
    error,
    helperText,
    fullWidth,
    disabled,
    required,
    freeSolo,
    bankAccounts,
    onChange,
}: BankAccountAutocompleteProps) => {
    const { t } = useTranslation('payout');

    // TODO: Type (bban/iban)
    return (
        <Autocomplete
            freeSolo={freeSolo}
            options={bankAccounts}
            filterOptions={(options, state) => {
                const re = new RegExp(state.inputValue, 'ig');
                return options.filter(o => o.bank_account_number.match(re) || o.nickname.match(re));
            }}
            getOptionLabel={(option => `${option.nickname} - ${option.bank_account_number}`)}
            disablePortal
            fullWidth={fullWidth}
            onChange={(_, value) => onChange(name, value, typeof value !== 'string' && !!value
                ? value.bank_account_type
                : 'bban')}
            onInputChange={(_, value) => onChange(name, value, 'bban')}
            renderInput={(props) => (
                <TextField
                    {...props}
                    name={name}
                    label={t('bank_account.number_bban')}
                    error={error}
                    helperText={helperText}
                    required={required}
                    disabled={disabled}
                />
            )}
        />
    );
};

export default BankAccountAutocomplete;
